import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';

import { Box } from './Box';
import { Icon } from './Icon';

export interface TitleAndCloseProps {
  title?: string;
  subtitle?: string | React.ReactNode;
  titleAlignment?: 'left' | 'center';
  leftAdornment?: React.ReactNode;
  rightAdornment?: React.ReactNode;
  onClose?: () => void;
  noWrap?: boolean;
  titleVariant?: 'h5' | 'h6';
}

export const TitleAndClose: React.FC<TitleAndCloseProps> = ({
  title,
  subtitle,
  titleAlignment = 'left',
  onClose,
  leftAdornment,
  rightAdornment,
  titleVariant = 'h5',
  noWrap,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: titleAlignment == 'center' ? 'center' : 'space-between',
        alignItems: 'flex-start',
        px: 2,
        pb: 2,
        maxWidth: '100%',
      }}
    >
      <Box
        sx={{
          maxWidth: 'calc(100% - 50px)',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {leftAdornment && (
          <Box pr={1} pt={2}>
            {leftAdornment}
          </Box>
        )}

        <Box
          sx={{
            minHeight: '52px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
            pt: 2,
            maxWidth: '100%',
          }}
        >
          <Typography
            noWrap={noWrap}
            variant={titleVariant}
            sx={[
              {
                width: '100%',
                py: 0,
                textAlign: titleAlignment,
              },
              !noWrap && {
                overflow: 'hidden',
                display: '-webkit-box',
                WebkitLineClamp: 4,
                WebkitBoxOrient: 'vertical',
              },
            ]}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mt: 1, ml: '1px' }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          mt: 2,
        }}
      >
        {rightAdornment}
        {onClose && (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              color: (theme) => theme.vars.palette.neutral[500],
              ml: 1,
            }}
          >
            <Icon
              color="action"
              icon={icon({ name: 'times', style: 'regular' })}
            />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};
